'use client';

import PageSectionHeader from '@ui/PageSectionHeader';

interface HomeSectionProps {
  title?: string;
  href?: string;
  target?: string;
  linkText?: string;
  children: React.ReactNode;
  className?: string;
  subtitle?: string;
}

export default function HomeSection({
  title,
  href,
  target,
  linkText,
  children,
  className,
  subtitle,
}: HomeSectionProps) {
  return (
    <div
      className={`flex w-full flex-col sm:mx-auto sm:max-w-[150rem] ${className} overflow-visible`}
    >
      {title && (
        <PageSectionHeader
          title={title}
          href={href}
          target={target}
          linkText={linkText}
          subtitle={subtitle}
        />
      )}

      <div className="h-full pt-[2rem]">{children}</div>
    </div>
  );
}
